<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="ms_code,ma_code,pr_code,pr_detail,pr_orispeccode,ms_vendname"
      placeholder="输入单据编号、外协单号、产品进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/out_prod/scrap/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.ms_code}}</p>
          <p class="list-item-muted">
            {{item.ms_vendname}}
            <br />
            {{item.createTime}}
          </p>
        </div>
        <div class="weui-cell__ft">
          <p v-format="'¥#,##0.00'">{{item.ms_total}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.ms_status!='已审核'}"
          >{{item.ms_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}笔</label>
      <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('ms_total')}}</em>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/make/makescrap/list",
      filters: [
        {
          type: "date",
          name: "makeScrap.createTime"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
              condition: "ms_class = '外协报废'"
            },
            {
              value: 1,
              label: "待报废",
              condition: "ms_class = '外协报废' AND ms_status='未审核'"
            },
            {
              value: 2,
              label: "已报废",
              condition: "ms_class = '外协报废' AND ms_status='已审核'"
            }
          ]
        }
      ]
    };
  }
};
</script>